import { useQuery, QueryResult } from '@apollo/client';
import { gql } from 'graphql-tag';
import {
  GetGuestVisitByIdQuery,
  GetGuestVisitByIdQueryVariables,
} from './__generated__/useVisitDetails.generated';

// Re-export types for backwards compatibility
export type GetGuestVisitById = GetGuestVisitByIdQuery;
export type GetGuestVisitByIdVariables = GetGuestVisitByIdQueryVariables;
export type GetGuestVisitById_getGuestVisitById = NonNullable<
  GetGuestVisitByIdQuery['getGuestVisitById']
>;

export const GET_VISIT_BY_ID = gql`
  query GetGuestVisitById($guestVisitId: ID!) {
    getGuestVisitById(guestVisitId: $guestVisitId) {
      id
      visitId
      customVisitType
      visitType
      status
      startTime
      checkinOn
      checkoutOn
      arrivalInstructions
      guest {
        id
        name
      }
      hosts {
        hostUserId
        isVisibleToGuests
        host {
          id
          name
          avatar
          email
        }
      }
      arrivalLocation {
        id
        name
        address
        timezone
        isHealthCheckpointRequired
      }
      healthCheckpointSurveyResponse {
        id
        status
      }
    }
  }
`;

export const useVisitDetails = (
  guestVisitId: GetGuestVisitByIdQueryVariables['guestVisitId']
): QueryResult<GetGuestVisitByIdQuery, GetGuestVisitByIdQueryVariables> =>
  useQuery<GetGuestVisitByIdQuery, GetGuestVisitByIdQueryVariables>(
    GET_VISIT_BY_ID,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
      variables: {
        guestVisitId,
      },
    }
  );
